import { render, staticRenderFns } from "./newContent.vue?vue&type=template&id=0087e746&scoped=true"
import script from "./newContent.vue?vue&type=script&lang=js"
export * from "./newContent.vue?vue&type=script&lang=js"
import style0 from "./newContent.vue?vue&type=style&index=0&id=0087e746&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0087e746",
  null
  
)

export default component.exports